<template>
  <div class="hello">
      <div class='container'>
            <transition name="fade">
                <div v-if="loadingItems" class="loading">
                    <p>{{loadingMessage}}</p>
                </div>
            </transition>
            <transition name="fade">
                <div v-if="performingRequest" class="loading">
                    <p> Adding your post </p>
                </div>
            </transition>

            <transition name="fade">
                <div v-if="addingFile" class="loading">
                    <p>Uploading Image...</p>
                </div>
            </transition>
        </div>

        <!-- Modal to show image error -->
        <!-- Error modal if not image type -->
        <b-modal id="modal-error" ok-only title="Error" ok-title="OK">
            {{errMsg}}
        </b-modal>

        <!-- Modal to add user handle  and accept terms -->
        <b-modal :no-close-on-backdrop="true" id='addusercred' title="Choose a display name"  ok-title ='Accept' cancel-title ='Cancel'  @ok="saveUserCreds">
            <p class="my-4">Enter a display handle. </p>
            <small>This display handle will show, along with your company's name in all your posts</small>
            <b-form-input v-model="userHandle" ></b-form-input>
            <div v-if="handleExists" style='color:red'>Sorry this handle is already taken</div>
        </b-modal>

    <b-container>

        <!-- Title -->
        <b-row>
            <b-col>
                <h4 v-if="postInfo.subject" style="margin-top:20px">{{postInfo.subject}}</h4>
            </b-col>
        </b-row>

        <!-- Original Post -->
        <b-card v-if="postInfo.subject"  header-tag="header"  header-bg-variant="info" border-variant="info" header-text-variant="white"
         footer-tag="footer">
            <!-- Header -->
            <template #header >
                <small>By: @{{postInfo.createdbyhandle}}, {{postInfo.createdbycompany}} on {{getTimeString(postInfo.createdOn.seconds)}}</small>
            </template>
            Original Post: <small>{{postInfo.originalpost}}</small>

            <!-- Image Button -->
            <br v-if="postInfo.imagethumburl1">
            <b-button variant="light" v-b-modal.infoimagemodal v-if="postInfo.imagethumburl1" style="margin-top:20px" >
                <img :src="postInfo.imagethumburl1" width="100" fluid alt="Logo image">
            </b-button>
            <!-- Large image modal -->
            <b-modal size="xl" id="infoimagemodal" ok-only ok-title="close">
                <div style="text-align:center; margin:auto">
                    <img :src="postInfo.imageurl1" width="500" fluid alt="Logo image">
                </div>
            </b-modal>
            <template #footer>
                <!-- Upvote and Downvote -->
                <b-button variant="light" size="sm" @click="upvoteThread(postInfo, 1)"><font-awesome-icon icon="thumbs-up"/></b-button>
                <b-button variant="light" style="margin-left:10px" size="sm" @click="upvoteThread(postInfo, -1)"><font-awesome-icon icon="thumbs-down"/></b-button>
                <b-button v-if="postInfo.createdbyuid!=currentUser.uid"  v-b-modal="'SendMsgOriginal' + postInfo.createdbyuid" variant="light" style="margin-left:10px" size="sm"><font-awesome-icon icon="comment"/> Send a private message</b-button>
                <!-- Send message modal -->
                <b-modal size="lg" :id="'SendMsgOriginal' + postInfo.createdbyuid" title="Send a Message"  hide-footer>
                    <div class='col-12'>
                        <sendmessage  :receiverId="postInfo.createdbyuid" :receiverName="postInfo.createdbycompany" :arrayDefaultMessages="arrayDefaultMessages" :modalid="'SendMsgOriginal' + postInfo.createdbyuid" @closeMessageModal="closeMessageModal"/>
                    </div>
                </b-modal>
            </template>
        </b-card>

        
        <!-- Write a reply card -->
            <b-card v-if="currentUser" style="margin-top:20px" header-bg-variant="primary" border-variant="primary" header-text-variant="white">
                <!-- Header -->
                <!--
                <template #header >
                    Reply
                    <small style="">By: @{{userProfile.userhandle}}, {{userProfile.company}}</small>
                </template>
                -->
                <!-- Post Details -->
                <b-form-group label="Write a reply" label-size="m" label-align-sm="top" label-for='description'>
                    <b-form-textarea  size="sm" id='description' v-model="theReply" rows="3" max-rows="6"></b-form-textarea>
                </b-form-group>
                <!-- Image -->
                <input id="image1"  @change="onLogoFileChanged($event, 'image1')"  type="file" hidden>
                <img v-if="imagethumburl1" @click="chooseFiles($event, 'image1')" style="cursor: pointer;" height="100px" :src="imagethumburl1"/>
                <b-button v-else @click="chooseFiles($event, 'image1')"><font-awesome-icon icon="camera" /> Optional Image</b-button>
                <!-- Submit -->
                <b-button variant="primary" style="margin-left:10px" :disabled="theReply.length<1" @click="checkUserCreds()">Submit</b-button>
            </b-card>

            <!-- Sign in, if no user -->
        <b-row v-if='!currentUser'>
            <b-col>
                <b-button size="lg" class="m-md-2" variant="info" @click="$router.push('/createaccount')">
                    Join Kegseeker to post on this thread
                </b-button>
            </b-col>
        </b-row>

        <div v-if="postsArray.length>0">
            <!-- Page controls -->
            <b-row id='toppagecontrol' style="margin-top:40px">
                <b-col  sm="9">
                    <b-pagination  size="sm"
                        v-model="currentPage"
                        :total-rows="totalLength"
                        :per-page="perPage"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                    ></b-pagination>
                </b-col>
                <b-col sm="3">
                        <b-form-group  label-size="sm" 
                            label-cols-sm="6"
                            label="Per Page"
                            label-align-sm="right"
                            label-for="size"
                            style="width:auto"
                            >
                            <b-form-select size="sm"
                                style="width:auto"
                            id="size"
                            v-model="perPage"
                            :options="pageOptions"
                            ></b-form-select>
                        </b-form-group>
                </b-col>
            </b-row>

            <!-- Forum cards -->
            <!-- All other reply cards -->
            <b-card v-for="(thePost, index) in getDisplayArray" :key="'card' + index" header-tag="header" style="margin-top:20px" 
                footer-tag="footer">
                <!-- Header -->
                <template #header >
                    <small style="color:gray">By: @{{thePost.createdbyhandle}}, {{thePost.createdbycompany}} on {{getTimeString(thePost.createdOn.seconds)}}</small>
                </template>
                <small>{{thePost.post}}</small>

                <!-- Image -->
                <div v-if="thePost.imagethumburl1">
                    <b-button  variant="light" v-if="thePost.imagethumburl1" v-b-modal="'modalpostimage'+thePost.postid" style="margin-top:20px" >
                        <img :src="thePost.imagethumburl1" width="100" fluid alt="Logo image">
                    </b-button>
                    <!-- Large image modal -->
                    <b-modal size="xl" :id="'modalpostimage'+thePost.postid" ok-only ok-title="close">
                        <div style="text-align:center; margin:auto">
                            <img :src="thePost.imageurl1" width="500" fluid alt="Logo image">
                        </div>
                    </b-modal>
                </div>
                <template #footer>
                    <!-- Upvote and Downvote -->
                    <b-button variant="light" size="sm" @click="upvoteMessage(thePost, 1)"><font-awesome-icon icon="thumbs-up"/></b-button>
                    <b-button variant="light" style="margin-left:10px" size="sm" @click="upvoteMessage(thePost, -1)"><font-awesome-icon icon="thumbs-down"/></b-button>
                    <small style="margin-left:20px" v-if="thePost.votes!=0"><span v-if="thePost.votes>0">+</span>{{thePost.votes}} votes</small>
                    <b-button v-if="thePost.createdbyuid!=currentUser.uid" v-b-modal="'SendMsg'+ thePost.createdbyuid+index" variant="light" style="margin-left:10px" size="sm"><font-awesome-icon icon="comment"/> Send a private message</b-button>
                </template>
                <!-- Send message modal -->
                <b-modal size="lg" :id="'SendMsg' + thePost.createdbyuid+index" title="Send a Message"  hide-footer>
                    <div class='col-12'>
                        <sendmessage  :receiverId="thePost.createdbyuid" :receiverName="thePost.createdbycompany" :arrayDefaultMessages="arrayDefaultMessages"  :modalid="'SendMsg' + thePost.createdbyuid+index" @closeMessageModal="closeMessageModal" />
                    </div>
                </b-modal>
            </b-card>

            <!-- Page controls -->
            <b-row style="margin-top:20px">
                <b-pagination size="sm"
                    v-model="currentPage"
                    :total-rows="totalLength"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    @change="pageChanged"
                ></b-pagination>

            </b-row>


        </div>
        <!-- End of div that contains all replies -->

    </b-container>

    <div id="footerid">
        <footer><pagefooter/></footer>
    </div>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')
import firebase from 'firebase/app';
import axios from 'axios'
import {timeConverterObject} from '../Myfunctions'
import {timeConverter} from '../Myfunctions'
import Pagefooter from '../Pagefooter'
import Sendmessage from '../Sendmessage'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'currentForumThreadId']),
        //Main display array
        getDisplayArray: function () {

            if(this.postsArray.length<1) return []

            var displayBeerList=[]
            var paginatedList = []
            displayBeerList=this.postsArray

            this.totalLength = displayBeerList.length

            var indexStart = (parseInt(this.currentPage-1))*parseInt(this.perPage)
            var indexStop = indexStart + parseInt(this.perPage)

            if (indexStop>displayBeerList.length) indexStop = displayBeerList.length

            for (var k = indexStart; k<indexStop; k++){
                paginatedList.push(displayBeerList[k])
            }
            return paginatedList
        },

        

    },

    components: {
        Pagefooter,
        Sendmessage,
    },

    data() {
        return {
            loadingItems:false,
            loadingMessage:'',
            performingRequest:false,
            localThreadId:'',
            threadDetails:{},
            currentPage:1,
            perPage:25,
            pageOptions: [
                    { value: '24', text: '25' },
                    { value: '48', text: '50' },
                    { value: '96', text: '100' },
                    { value: '9999999999999', text: 'All' },
                    ],
            totalLength:0,
            threatTitleInfo:{},
            postInfo:{},
            postsArray:[],
            theReply:'',
            arrayDefaultMessages:[],
            userHandle:'',
            handleExists:false,
            errMsg:'',

            imageurl1:'',
            imageurl2:'',
            imageurl3:'',
            imageurl4:'',
            imageurl5:'',
            imageurl6:'',
            imagethumburl1:'',
            imagethumburl2:'',
            imagethumburl3:'',
            imagethumburl4:'',
            imagethumburl5:'',
            imagethumburl6:'',

            addingFile:false,
            cloudinary: {
                logoFullPreset:'forumfullimage',
                logoThumbPreset:'forumthumbnailimage',
                apiKey: '629997215451183',
                cloudName: 'lo4xxr5lr',
                uploadURL:'https://api.cloudinary.com/v1_1/lo4xxr5lr/upload'
            },

        }
    },

    methods:{

        //Check if user has handle
        checkUserCreds(){
            //If no screen name, ask for screen name
            if(!this.userProfile.userhandle) this.$bvModal.show("addusercred")
            //Else show start new thread
            else this.submitNewPost()

        },
        //Save users new screen name
        saveUserCreds(bvModalEvt){
            //Wait till this screen name is checked
            bvModalEvt.preventDefault()
            this.handleExists=false
            this.errMsg=""
            fb.displayHandlesCollection.where('userhandle', '==', this.userHandle).get().then(docs => {
                docs.forEach(doc => {
                    const theData = doc.data()
                    this.handleExists=true
                    this.userHandle=""
                })

                //If handle doesn't exist, assign it to user
                if(!this.handleExists){
                    //Assign to user
                    fb.usersCollection.doc(this.currentUser.uid).update({
                        userhandle:this.userHandle
                    })
                    //Add to handles collection
                    fb.displayHandlesCollection.doc(this.currentUser.uid).set({userhandle:this.userHandle, uid:this.currentUser.uid, company:this.userProfile.company})
                    this.$bvModal.hide("addusercred")
                    //Add post
                    this.submitNewPost()
                }
            }).catch(err => {
                console.log(err)
            })

        },

        //Page changed
        pageChanged(){
            //window.scrollTo(0,0)
            console.log("Page changed")
            document.getElementById('toppagecontrol').scrollIntoView();
        },

        //Get the forum details
        getForumDetails(){
            this.loadingMessage=" Loading "
            this.loadingItems=true

            var docRefTitle = fb.forumTitlesCollection.doc(this.localThreadId);
            //Get thread title info
            docRefTitle.get().then((doc) => {
                this.threatTitleInfo = doc.data()
                this.threatTitleInfo.docId = doc.id
                this.postInfo = this.threatTitleInfo

            })
            var localPostsList = []
            fb.forumsCollection.where("threadid", "==", this.localThreadId).get().then(docs => {
                    docs.forEach(doc => {
                        var theData = doc.data()
                        theData.docId=doc.id
                        localPostsList.push(theData)
                    })
                }).then(res => {
                    //Sort by newest post
                    function compare(a, b) {
                        const costA = parseInt(a.createdOn.seconds)
                        const costB = parseInt(b.createdOn.seconds)

                        let comparison = 0;
                        if (costA <costB) {
                                comparison = 1;
                        } else if (costA>costB) {
                                comparison = -1;
                        }
                            return comparison;
                    }
                    localPostsList.sort(compare);
                    this.postsArray = localPostsList
                    this.loadingItems=false

                })
                .catch(err => {
                    console.log("Error")
                    this.loadingItems=false
                })

        },

        //Get time string
        getTimeString(theTime){
            var dateString = timeConverter(theTime)
            return dateString

        },

        //Choose image files
        chooseFiles(event, imagenumber) {
            console.log("Choosing image")
            document.getElementById(imagenumber).click()
        },

        //Image file changed
        onLogoFileChanged (event, imagenumber) {
            console.log("File changed: " + imagenumber)
            this.selectedFile = event.target.files[0]
            const name = event.target.files[0].name;
            const lastDot = name.lastIndexOf('.');

            this.fileName = name.substring(0, lastDot);
            this.fileExtension = name.substring(lastDot + 1);

            console.log(this.fileName, this.fileExtension)

            //Check file extention
            this.fileExtension=this.fileExtension.toLowerCase()
            if(this.fileExtension!='jpg'&&this.fileExtension!='jpeg'&&this.fileExtension!='png'){
                this.errMsg="Image must be a JPEG or PNG"
                this.$bvModal.show("modal-error")
                return
            }
            this.uploadLogotoCloudinary(imagenumber)
        },

        //Upload file
        uploadLogotoCloudinary(imagenumber){
            this.addingFile = true
            let data = new FormData();
            data.append('file', this.selectedFile); 

            //Upload full image
            data.append('upload_preset', this.cloudinary.logoFullPreset);
            axios
                .post(this.cloudinary.uploadURL, data)
                .then((result) => {
                    if(result.data.secure_url){
                        console.log("URL main: " + result.data.secure_url)
                        if(imagenumber=='image1') this.imageurl1 = result.data.secure_url
                        else if(imagenumber=='image2') this.imageurl2 = result.data.secure_url
                        else if(imagenumber=='image3') this.imageurl3 = result.data.secure_url
                        else if(imagenumber=='image4') this.imageurl4 = result.data.secure_url
                        else if(imagenumber=='image5') this.imageurl5 = result.data.secure_url
                        else if(imagenumber=='image6') this.imageurl6 = result.data.secure_url
                    }
                    this.addingFile = false

                })
                .catch((err) => {
                    console.log('Ax Error:' + err);
                    
                    this.addingFile = false
                }) 

            //Upload thumbnail
            let thumbdata = new FormData();
            thumbdata.append('file', this.selectedFile); 
            thumbdata.append('upload_preset', this.cloudinary.logoThumbPreset);

            axios
                .post(this.cloudinary.uploadURL, thumbdata)
                .then((result) => {
                    if(result.data.secure_url){
                        console.log("URL thumbnail: " + result.data.secure_url)
                        //Add thumbnail url
                        if(imagenumber=='image1') this.imagethumburl1 = result.data.secure_url
                        else if(imagenumber=='image2') this.imagethumburl2 = result.data.secure_url
                        else if(imagenumber=='image3') this.imagethumburl3 = result.data.secure_url
                        else if(imagenumber=='image4') this.imagethumburl4 = result.data.secure_url
                        else if(imagenumber=='image5') this.imagethumburl5 = result.data.secure_url
                        else if(imagenumber=='image6') this.imagethumburl6 = result.data.secure_url
                    }
                    this.addingFile = false
                })
                .catch((err) => {
                    console.log('Ax Thumb Error:' + err);
                    this.addingFile = false
                })

        },

        //Submit new post
        submitNewPost(){
            this.performingRequest = true
            console.log("Submitting new post")
            var min=11111111111111111; 
            var max=99999999999999999; 
            var randomId = Math.floor(Math.random() * (+max - +min)) + +min; 
            var randomIdString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

            var theDate = new Date()

            //Create  post info
            this.postInfo.lastpostdate = theDate
            this.postInfo.lastpostcomany = this.userProfile.company
            this.postInfo.lastposthandle = this.userHandle
            this.postInfo.lastpostuid = this.currentUser.uid
            this.postInfo.lastpost = this.theReply
            this.postInfo.totalposts = this.postInfo.totalposts + 1 
            //Add current user to voted uid
            var voteduid = [this.currentUser.uid]

            //Create post object
            var newPost =  {createdOn: theDate, post:this.theReply
                    , createdbyhandle:this.userHandle, createdbyuid:this.currentUser.uid, createdbyemail:this.currentUser.email
                    , createdbycompany:this.userProfile.company, isreply:1, postid: randomIdString, votes:0
                    , voteduid:voteduid, threadid: this.localThreadId, imageurl1: this.imageurl1, imagethumburl1: this.imagethumburl1}

            //Add to local posts array
            console.log("Splicing new post")
            console.log(newPost)
        

            //Add as single object
            fb.forumsCollection.add(newPost)
                .then((response) => {
                    setTimeout(() => { this.performingRequest = false }, 1500)
                    this.theReply = ''
                    this.imageurl1=''
                    this.imagethumburl1=''
                    this.imageurl2=''
                    this.imagethumburl2=''
                    this.imageurl3=''
                    this.imagethumburl3=''
                    this.imageurl4=''
                    this.imagethumburl4=''
                    this.imageurl5=''
                    this.imagethumburl5=''
                    this.imageurl6=''
                    this.imagethumburl6=''
                })

            //Add to local array
            this.postsArray.splice(0, 0, newPost);

            //Update forum titles
            var newPostTitleRef = fb.forumTitlesCollection.doc(this.localThreadId)
            newPostTitleRef.update(this.postInfo)
                        
        },

        //Upvote message
        upvoteMessage(thePost, vote){
            //Set voted uid
            console.log("Voting on message id: " + thePost.docId)
            var voteduid=[]
            if(thePost.voteduid&&thePost.voteduid.length>0) voteduid=thePost.voteduid

            //Already voted
            if(voteduid.includes(this.currentUser.uid)){
                this.$bvToast.toast('You have already voted on this post', {
                    title: 'Already voted!',
                    solid:true,
                    variant: 'danger',
                    autoHideDelay: 5000,
                    appendToast: false
                })
                return
            }
            //Hasn't voted
            else{
                //Vote
                var increment = firebase.firestore.FieldValue.increment(vote);
                fb.forumsCollection.doc(thePost.docId).update({ votes: increment});
                voteduid.push(this.currentUser.uid)
                //Add to voted uid
                fb.forumsCollection.doc(thePost.docId).update({ voteduid: firebase.firestore.FieldValue.arrayUnion(this.currentUser.uid)})
                .then((response) => {
                })
                this.$bvToast.toast('Thanks for voting', {
                    title: 'Voted!',
                    solid:true,
                    variant: 'success',
                    autoHideDelay: 5000,
                    appendToast: false
                })

            }
        },

        //Upvote thread
        upvoteThread(postInfo, vote){
            console.log("Vote Thread = " + this.localThreadId)
            console.log("Vote = " + vote)
            var hasVoted = this.threatTitleInfo.voteduid.includes(this.currentUser.uid);
            //Check if user already voted
            if(hasVoted){
                this.$bvToast.toast('You have already voted on this thread', {
                    title: 'Already voted!',
                    solid:true,
                    variant: 'danger',
                    autoHideDelay: 5000,
                    appendToast: false
                })
                return
            }
            var increment = firebase.firestore.FieldValue.increment(vote);
            fb.forumTitlesCollection.doc(this.localThreadId).update({ votes: increment});

            //Add to voted uid
            fb.forumTitlesCollection.doc(this.localThreadId).update({ voteduid: firebase.firestore.FieldValue.arrayUnion(this.currentUser.uid)})
                .then((response) => {
                    this.threatTitleInfo.voteduid.push(this.currentUser.uid)
                })

            this.$bvToast.toast('Thanks for voting', {
                title: 'Voted!',
                solid:true,
                variant: 'success',
                autoHideDelay: 5000,
                appendToast: false
            })
        },

        //Close messages modal
        closeMessageModal(modalid){
            this.$bvModal.hide(modalid)
        }

    },

    mounted(){
        if(this.userProfile.userhandle) this.userHandle=this.userProfile.userhandle

        //If direct link
        if(this.$route.params.threadid ){
            console.log("route param threadid id = " + this.$route.params.threadid )
            this.localThreadId = this.$route.params.threadid 
        }
        else{
            this.localThreadId = this.currentForumThreadId
        }

        this.getForumDetails()
    },
}
</script>

